export const USER = "USER";
export const VENDOR = "VENDOR";
export const ADMIN = "ADMIN";
export const PARTNERS = "PARTNERS";
export const MEMBER = "MEMBER";